export enum ProjectFilesTreeContextMenuOptions {
    Add,
    Upload,
    Rename,
    Delete
  }
